import { generateFeatures } from './convert-to-geojson';

/**
 * Toggle visning av ett kartlager
 * @param {boolean} isSelected - Om lagret ska visas
 * @param {string} type - Layer type (t.ex. 'districts', 'aregion', etc.)
 * @param {string} color - Färg för lagret
 * @param {Object} mapState - MapStateManager-instans
 * @param {Function} mapService - MapService med fetchSpatialInfo och fetchGeoJSON
 * @param {Function} fetchGeoJSON - Funktion för att hämta GeoJSON för en type
 * @param {string} districtType - District type
 * @param {string} scenarioId - Scenario ID
 * @param {Function} onLoadingChange - Callback för loading state (isLoading)
 */
export async function toggleLayer(
        isSelected,
        type,
        color,
        mapState,
        mapService,
        fetchGeoJSON,
        districtType,
        scenarioId,
        onLoadingChange
    ) {
        onLoadingChange(true);

        try {
            // Först, återställ alla styles för denna layer type
            mapState.getMap().data.forEach((feature) => {
                if ((feature.getProperty('type') === `maplayer-${type}`)) {
                    mapState.getMap().data.revertStyle(feature);
                    if (!isSelected) {
                        // Om vi avaktiverar, ta bort feature från kartan
                        mapState.getMap().data.remove(feature);
                    }
                }
            });

            if (isSelected) {
                await showLayer(
                    type,
                    color,
                    mapState,
                    mapService,
                    fetchGeoJSON,
                    districtType,
                    scenarioId
                );
            }
        } finally {
            onLoadingChange(false);
        }
}

/**
 * Visa ett kartlager
 */
async function showLayer(type, color, mapState, mapService, fetchGeoJSON, districtType, scenarioId) {
        let region;

        if (type === 'districts') {
            // För districts, använd fetchSpatialInfo
            const districts = await mapService.fetchSpatialInfo(districtType, scenarioId);
            const features = [];
            districts.forEach((d, i) => {    
                if (d && d.geoJson) {
                    const district = JSON.parse(d.geoJson);
                    features.push(generateFeatures(district[0], `${district[0].properties.name}${i}`, 'maplayer-districts'));
                }
            });
            region = {
                type: "FeatureCollection",
                features
            };
        } else {
            // För andra typer, använd fetchGeoJSON
            region = await fetchGeoJSON(type);
            region = {
                ...region,
                features: region.features.map(feat => {
                    return {
                        ...feat,
                        id: `maplayer-${feat.id}`,
                        properties: {
                            ...feat.properties,
                            type: `maplayer-${type}`
                        }
                    };
                })
            };
        }

        // Rendera GeoJSON på kartan
        mapState.styleManager.renderGeoJSON(region, mapState.getMap());

        // Applicera styling
        mapState.getMap().data.forEach((feature) => {
            const featureType = feature.getProperty('type');
            if (!featureType) return;
            if (featureType.indexOf('maplayer-') > -1) {
                mapState.getMap().data.overrideStyle(feature, { 
                    zIndex: 1
                });               
            }
                
            if (featureType === `maplayer-${type}`) {
                mapState.getMap().data.overrideStyle(feature, { 
                    strokeWeight: 5, 
                    strokeColor: color,
                    fillOpacity: 0.1,
                    fillColor: color,
                    clickable: false,
                    visible: true,
                    zIndex: 2
                });
            }
        });
}

